<script>
import {
  SubirArchivo,
  SubirArchivoFormulario,
  descargarDocumentoFormulario,
  crearDocumento,
  descargarDocumento
} from "../../apiService/request/Documentos";
import { consultarInformacionMomentosEncuentro } from "../../apiService/request/CrudEncuentro";
import Icono from "../Icono/Icono";
import SubirArchivoV2 from "../SubirArchivoV2/SubirArchivoV2";
import DescargarArchivoV2 from "../DescargarArchivoV2/DescargarArchivoV2";

export default {
  data() {
    return {
      iconoCargar:
        "M35.9,18.2C35,11.3,29,6,22,6c-5.6,0-10.5,3.3-12.8,8.3C3.8,15.6,0,20.4,0,26c0,6.6,5.4,12,12,12h22c5.5,0,10-4.5,10-10C44,23.1,40.6,19.1,35.9,18.2z M34,36H12C6.5,36,2,31.5,2,26c0-4.8,3.4-8.9,8.1-9.8l0.5-0.1l0.2-0.5C12.7,11,17.1,8,22,8c6.3,0,11.5,4.9,12,11.1L34,20l0.8,0.1c4.1,0.4,7.2,3.8,7.2,8C42,32.4,38.4,36,34,36z M28.7,21.3c0.4,0.4,0.4,1,0,1.4C28.5,22.9,28.3,23,28,23s-0.5-0.1-0.7-0.3L23,18.4V31c0,0.6-0.4,1-1,1s-1-0.4-1-1V18.4l-4.3,4.3C16.5,22.9,16.3,23,16,23s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l6-6c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.5-0.1,0.8,0c0.1,0.1,0.2,0.1,0.3,0.2L28.7,21.3zM0,0h44 M44,44H0",
      iconoCerrar:
        "M43.7,42.3c0.4,0.4,0.4,1,0,1.4C43.5,43.9,43.3,44,43,44s-0.5-0.1-0.7-0.3L22,23.4L1.7,43.7C1.5,43.9,1.3,44,1,44s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L20.6,22L0.3,1.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L22,20.6L42.3,0.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L23.4,22L43.7,42.3z",
      iconoDescargar:
        "M43,37.3H1c-0.6,0-1,0.4-1,1V43c0,0.6,0.4,1,1,1h42c0.6,0,1-0.4,1-1v-4.7C44,37.8,43.6,37.3,43,37.3z M42,42H2v-2.7h40V42zM10.8,23.9c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8.8,8.8V1c0-0.6,0.4-1,1-1s1,0.4,1,1v30.3l8.8-8.8c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L22.7,34.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.3,0.1-0.4,0.1s-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2L10.8,23.9z",
      iconoFormulario:
        "M17,18c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1s-0.4,1-1,1H18C17.4,19,17,18.6,17,18z M30,23H18c-0.6,0-1,0.4-1,1s0.4,1,1,1h12c0.6,0,1-0.4,1-1S30.6,23,30,23z M30,29H18c-0.6,0-1,0.4-1,1s0.4,1,1,1h12c0.6,0,1-0.4,1-1S30.6,29,30,29z M30,35H18c-0.6,0-1,0.4-1,1s0.4,1,1,1h12c0.6,0,1-0.4,1-1S30.6,35,30,35z M38,11l0,31c0,1.1-0.9,2-2,2H8c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h19c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.3,0.2l10,10c0.1,0.1,0.2,0.2,0.2,0.3c0,0,0,0.1,0,0.1C38,10.8,38,10.9,38,11C38,11,38,11,38,11z M28,10h6.6L28,3.4V10z M36,42l0-30h-9c-0.6,0-1-0.4-1-1V2H8l0,40L36,42z M14,17h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,17,14,17z M14,23h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,23,14,23z M14,29h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,29,14,29z M14,35h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,35,14,35z M44,0v44 M0,0v44",
      fileSelected: null,
      files: [],
      cantidadArchivosDescargar: 0,
      fab: false,
      loading: false,
      loadingVisualizar: false
    };
  },
  async created() {
    // await this.consultarArchivos();
  },
  props: {
    paciente: {
      type: Object,
      default: {}
    },
    visualizar: {
      type: Boolean,
      default: true
    },
    subir: {
      type: Boolean,
      default: true
    },
    coleccion: {
      type: String,
      default: null
    },
    verArchivos: {
      type: Boolean,
      default: true
    },
    nombreDocumento: String,
    id: String,
  },
  components: {
    Icono,
    SubirArchivoV2,
    DescargarArchivoV2
  },
  methods: {
    cantidadArchivos(longitud) {
      this.cantidadArchivosDescargar = longitud;
    },
    async changeInputSubir(event) {
      if (event && event.target && event.target.files){
        let cantidad;
        this.fileSelected = [...event.target.files];
        this.subirArchivo();
      }
    },
    async subirArchivo() {
      const files = this.fileSelected;
      if (files.length && !this.loading) {
        this.loading = true;
        const documento = this.paciente.documento;
        const nombrePaciente = this.paciente.nombre;
        const key = this.nombreDocumento;
        const id = this.id;
        const coleccion = this.coleccion;

        const mensaje = {
          data: {
            message: "Ocurrio un error cargando el archivo."
          },
          status: 500
        };
        this.loading = false;
        const response = await SubirArchivoFormulario(
          files,
          documento,
          nombrePaciente,
          key,
          id,
          coleccion
        );
        await this.consultarArchivos();
        this.$store.dispatch(
          "cambiarMensajeModal",
          !response.status ? mensaje : response
        );
        this.$store.dispatch("cambiarEstadoModal", true);
      }
    },
    limpiarInputSubir(event){
      if (event.target && event.target.value){
        event.target.value=null;
      }
    },
    async consultarArchivos() {
      if (this.verArchivos) {
        const id = this.id;
        const coleccion = this.coleccion;
        // if (!this.$store.getters.getCargando) {
        //   this.$store.dispatch("setCargando", true);
        // }
        if (id && coleccion) { 
          this.files = await descargarDocumentoFormulario(id, coleccion).then(
            res => {
              if(res && res.data) {
                return res.data;
              } else {
                return []
              }
            }
          );
        }
        this.$store.dispatch("setCargando", false);
      }
    },
    descargar(file) {
      window.open(file);
    },
    async visualizarDocumento() {
      this.loadingVisualizar = true;
      const ids = [this.id];
      const respuesta = await crearDocumento(ids);
      if (respuesta && respuesta.data) {
        this.loadingVisualizar = false;
        window.open(respuesta.data);
      }
    }
  }
};
</script>

<template src="./SubirArchivo.html"></template>
<style lang="scss" scoped src="./SubirArchivo.scss"></style>


// WEBPACK FOOTER //
// src/components/SubirArchivo/SubirArchivo.vue